import {
  Component,
  type InputSignal, input
} from '@angular/core';
import { TranslatePipe } from '../../pipes/translate.pipe';

@Component({
  selector: 'td-wb-detailed-spinner',
  templateUrl: 'detailed-spinner.component.html',
  styleUrls: ['./detailed-spinner.component.scss'],
  imports: [
    TranslatePipe
  ]
})
export class DetailedSpinnerComponent {
  spinnerSize: InputSignal<'medium' | 'small' | 'large'> = input<'medium' | 'small' | 'large'>('medium');

  getSpinnerSrc(): string {
    const baseURL = 'assets/core/images/spinner-';
    switch (this.spinnerSize()) {
      case 'small':
        return baseURL + 'small.png';
      case 'large':
        return baseURL + 'large.png';
      default:
        return baseURL + 'medium.png';
    }
  }
}
